<template>
  <a-modal
    ref="syncModal"
    title="同步操作"
    :width="500"
    :visible="visible"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="loading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item ref="username" label="用户工号" prop="username">
              <a-input v-model="form.username" placeholder="请输入用户工号" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { syncOaUserInfo } from '@/api/system/user'
// 表单字段
export default {
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      readOnly: false,
      visible: false,
      loading: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      // 表单属性:
      form: {
        username: undefined
      },
      // 输入框校验:
      rules: {
        nickName: [
          { required: true, message: '用户工号为必填', trigger: 'blur' },
          { max: 6, message: '最多输入6个字符', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    // 由于要用传进来的值做判断,将显示和隐藏放在内部做处理
    show () {
      this.form.username = '';
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
      this.reset()
    },
    confirm () {
      this.confirmLoading = true
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          syncOaUserInfo(this.form.username).then(response => {
            this.$message.success('同步成功');
            // 关闭本组件
            this.visible = false
            // 调用外部刷新列表方法
            this.$emit('handle-success')
            // 刷新表单
            this.reset()
            this.confirmLoading = false
          });
        } else {
          return (this.confirmLoading = false)
        }
      })
    },
    // 表单重置
    reset () {
      this.form = {
        username: undefined
      }
    }
  }
}
</script>
